module.exports = __webpack_public_path__ + "static/media/discord.13cb0bb1.svg";